import styled from "styled-components";

export const Title = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.2rem;
    margin-bottom: 15px;
    cursor: pointer;
    font-weight: bold;

    &:hover {
        opacity: 0.7;
    }
`;
